import { ScrollView } from 'react-native';

export function CustomScrollView(props) {
  if (!props) {
    props = {};
  }
  return (
    <ScrollView
      keyboardShouldPersistTaps="handled"
      {...props}
      contentContainerStyle={{
        flexGrow: 1,
        padding: 20,
        ... props.contentContainerStyle
      }}
    />
  );
}
